import { Percentage } from '@sparkdotfi/common-universal'
import { MoveRightIcon } from 'lucide-react'

import { formatPercentage } from '@/domain/common/format'
import { cn } from '@/ui/utils/style'

export interface TransactionOverviewApyChangeProps {
  currentApy: Percentage | undefined
  updatedApy: Percentage | undefined
  colorUpdated?: boolean
  currentApyTestId?: string
  updatedApyTestId?: string
}

export function TransactionOverviewApyChange({
  currentApy,
  updatedApy,
  colorUpdated = true,
  currentApyTestId,
  updatedApyTestId,
}: TransactionOverviewApyChangeProps) {
  if (!updatedApy) {
    return (
      <div data-testid={currentApyTestId} className="typography-label-2 text-primary">
        {formatPercentage(currentApy)}
      </div>
    )
  }

  if (!currentApy) {
    return (
      <div data-testid={updatedApyTestId} className="typography-label-2 text-primary">
        {formatPercentage(updatedApy)}
      </div>
    )
  }

  return (
    <div className="flex flex-row items-center gap-2.5">
      <div data-testid={currentApyTestId} className="typography-label-2 text-primary">
        {formatPercentage(currentApy)}
      </div>
      {!currentApy.eq(updatedApy) && (
        <>
          <MoveRightIcon className="icon-size-xxs icon-secondary" />
          <div
            data-testid={updatedApyTestId}
            className={cn(
              'typography-label-2',
              colorUpdated && currentApy.eq(updatedApy) && 'text-primary',
              colorUpdated && currentApy.gt(updatedApy) && 'text-system-error-primary',
              colorUpdated && currentApy.lt(updatedApy) && 'text-system-success-primary',
            )}
          >
            {formatPercentage(updatedApy)}
          </div>
        </>
      )}
    </div>
  )
}
